export const setGrayItem = (prop, value = 'Y') => {
  const grayListString = localStorage.getItem('grayList') || "{}";
  let grayList = {};
  try {
    grayList = JSON.parse(grayListString);
  }
  catch (e) {
    grayList = {};
  }
  grayList[prop] = value;
  localStorage.setItem('grayList', JSON.stringify(grayList));
};

export const removeGrayItem = (prop) => {
  const grayListString = localStorage.getItem('grayList') || "{}";
  let grayList = {};
  try {
    grayList = JSON.parse(grayListString);
  }
  catch (e) {
    grayList = {};
  }
  delete grayList[prop];
  localStorage.setItem('grayList', JSON.stringify(grayList));
};

export const checkGrayItem = (item, value = 'Y') => {
  const grayListString = localStorage.getItem('grayList');
  if (!grayListString) {
    return false;
  }
  let grayList = {};
  try {
    grayList = JSON.parse(grayListString);
  }
  catch (e) {
    grayList = {};
  }
  return grayList[item] === value;
};


// WEBPACK FOOTER //
// ./src/components/util/handleGrayByLocalstorage.js